import { Service, computed, signal } from '@angular/core';

interface RouteAccessNotice {
  message: string;

  /** Route the user was redirected to; the notice belongs to that page only. */
  url: string;
}

/**
 * Carries the short "you were sent to your own dashboard" message across the
 * role-guard redirect (CCWIS-174). Deliberately not a query param: tenancy and
 * role never travel in the URL, and an editable param would invite tampering.
 */
@Service()
export class RouteAccessNoticeService {
  private readonly notice = signal<RouteAccessNotice | null>(null);

  readonly message = computed(() => this.notice()?.message ?? null);

  deny(message: string, url: string): void {
    this.notice.set({ message, url });
  }

  dismiss(): void {
    this.notice.set(null);
  }

  /** Clears once the user moves off the page they were redirected to. */
  clearIfNavigatedAway(url: string): void {
    const current = this.notice();
    if (current && url.split('?')[0].split('#')[0] !== current.url) {
      this.notice.set(null);
    }
  }
}
